// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__h9EHF"};